import { render, staticRenderFns } from "./demandCheck.vue?vue&type=template&id=423e7c41&scoped=true&"
import script from "./demandCheck.vue?vue&type=script&lang=js&"
export * from "./demandCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423e7c41",
  null
  
)

export default component.exports